// extracted by mini-css-extract-plugin
module.exports = {"chevronNavigator":"PrevNextChevronNavigator_chevronNavigator__3rI_Y","chevron":"PrevNextChevronNavigator_chevron__1z57J"};